export const AUTHENTICATION = 'AUTHENTICATION'
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
export const LOGOUT = 'LOGOUT'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const RESET_PASSWORD = 'FORGOT_PASSWORD_RESPONSE'
export const MFA_SETUP = 'MFA_SETUP'
export const SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA'
export const MFA_AUTH_CHOOSE_FACTOR = 'MFA_AUTH_CHOOSE_FACTOR'
export const MFA_WEB_AUTHN_SETUP = 'MFA_WEB_AUTHN_SETUP'
export const MFA_REGISTER_CHOOSE_FACTOR = 'MFA_REGISTER_CHOOSE_FACTOR'
export const WEB_AUTHN_MFA = 'WEB_AUTHN_MFA'
export const VALIDATE_TOKEN = 'VALIDATE_TOKEN'
export const VALIDATE_COOKIE = 'VALIDATE_COOKIE'
export const VALIDATE_USER = 'VALIDATE_USER'
export const SSO = 'SSO'

export const mfaFactor = {
  totp: 'TOTP',
  webAuthN: 'WEB_AUTHN',
}
